<template>
  <b-modal id="detalhes-eprotocolo"
           ref="modal"
           title="Detalhes do Protocolo"
           no-close-on-backdrop
           no-close-on-esc
           class="protocoloDetalhes"
           header-class="protocoloDetalhes_header"
           body-class="protocoloDetalhes_body"
           content-class="protocoloDetalhes_content"
           size="xl">
    <template slot="modal-header">
      <div>
        <b class="ml-2">Detalhes do Protocolo</b>
      </div>
    </template>

    <div class="row mb-4">
      <div class="col-3">
        <label class="label">
          Número do protocolo
        </label>

        <div>
          {{ (protocolo && protocolo.protocol) || 'Não informado' }}
        </div>
      </div>

      <div class="col-3">
        <label class="label">
          Status
        </label>

        <div>
          {{ (protocolo && protocolo.statusLabels) || 'Não informado' }}
        </div>
      </div>

      <div class="col-3">
        <label class="label">
          Plataforma do solicitante
        </label>

        <div>
          {{ (protocolo && protocolo.requestingOrganization) || 'Não informado' }}
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-3">
        <label class="label">
          CNS do cartório solicitante
        </label>

        <div>
          {{ (protocolo && protocolo.responsibleNotaryCns) || 'Não informado' }}
        </div>
      </div>

      <div class="col-3">
        <label class="label">
          CPF do Requerente
        </label>

        <div>
          {{ formatCpf(protocolo && protocolo.requestingUserCpf) }}
        </div>
      </div>

      <div class="col-6">
        <label class="label">
          Nome do Requerente
        </label>

        <div>
          {{ (protocolo && protocolo.requestingUserName) || 'Não informado' }}
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-3">
        <label class="label">
          Serviço solicitado
        </label>

        <div>
          {{ (protocolo && protocolo.serviceType) || 'Não informado' }}
        </div>
      </div>

      <div class="col-9">
        <label class="label">
          Observações
        </label>

        <div>
          {{ (protocolo && protocolo.observations) || 'Não informado' }}
        </div>
      </div>
    </div>

    <div v-if="protocolo && protocolo.attachments && protocolo.attachments.length">
      <div v-if="!documentos || !documentos.length"
           class="row justify-content-center mt-4">
        <div class="col-12 d-flex justify-content-center">
          <b-spinner variant="primary" />
        </div>

        <div class="col-12 d-flex justify-content-center mt-2">
          <small>Carregando...</small>
        </div>
      </div>

      <div v-else
           class="row">
        <div class="col-3">
          <div class="MenuImagens">
            <div class="MenuImagens_header">
              Imagens
            </div>

            <div v-for="(documento, index) in documentos"
                 :key="index"
                 class="MenuImagens_imagem"
                 :class="{ 'MenuImagens_imagem_active': imageActive === index }"
                 @click="loadPdf (documento, index)">
              Documento {{ index + 1 }}
            </div>
          </div>
        </div>

        <div class="col-9">
          <div class="Imagem">
            <object class="document-preview embed-responsive"
                    :data="urlPDF"
                    type="application/pdf">

              <p>
                Seu browser não suporta arquivos pdf diretamente
                ou este arquivo não existe.
              </p>
            </object>
          </div>
        </div>
      </div>
    </div>

    <div v-else
         class="row">
      <div class="col-12">
        <b>
          Nenhum pdf adicionado ao protocolo
        </b>
      </div>
    </div>

    <template slot="modal-footer">
      <button class="btn btn-sm btn-primary text-nowrap mr-auto"
              @click="buscarArquivoEstruturado(protocolo.hash)">
        Visualizar arquivo estruturado
      </button>
      <button class="btn btn-sm btn-light px-3"
              @click="hide()">
        Voltar
      </button>
      <button
        class="btn btn-sm btn-primary text-nowrap btn-com-icone"
        @click="acessar(protocolo.hash)">
        <IconSvg icon="openInNew"
                 class="icon--sm" />
        Acessar protocolo
      </button>
    </template>
  </b-modal>
</template>

<script>
  // Services
  import EProtocoloService from '@/services/EProtocoloService'

  export default {
    name: 'EProtocoloModal',
    props: {
      protocolo: {
        type: Object,
        default: null
      }
    },
    data () {
      return {
        imageActive: 0,
        documentos: [],
        urlPDF: null
      }
    },
    watch: {
      protocolo: {
        immediate: true,
        handler (value) {
          if (value && value.attachments) {
            this.getDocumentos()
          }
        }
      }
    },
    methods: {
      abrirModal () {
        this.$refs.modal.show()
      },
      hide () {
        this.$refs.modal.hide()
        this.$emit('hide')
      },
      async loadPdf (id, index) {
        try {
          const response = await EProtocoloService.getPdfById(id)

          if (response && response.data) {
            this.changePDF(response.data, index)
          }
        } catch (error) {
          displayMessage('error', 'Error!', error.message)
        }
      },
      async getDocumentos () {
        if (!this.protocolo || !this.protocolo.attachments || !this.protocolo.attachments.length ) {
          return
        }

        try {          
          this.protocolo.attachments.forEach(item => {
            this.documentos.push(item.id)
          })

          this.loadPdf (this.documentos[0], 0)
        } catch (error) {
          displayMessage('error', 'Error!', error.message)
        }
      },
      changePDF (blob, index) {
        let url = window.URL.createObjectURL(blob)
        this.urlPDF = url
        this.imageActive = index
      },
      async buscarArquivoEstruturado (hash) {
        try {
          const response = await EProtocoloService.getArquivoEstruturado(hash)

          if (response && response.data && response.data.success) {
            const arquivoEstruturado = {...response.data.arquivoEstruturado.data, hash}

            this.$store.dispatch('eProtocolo/setArquivoEstruturado', arquivoEstruturado)
            this.$router.push('/eProtocolo-arquivos-estruturados')
          }
        } catch (error) {
          const mensagem = error.response.data.error
          displayMessage('error', '', mensagem)
        }
      },
      acessar (hash) {
        window.open(
          `https://protocoloh.registrocivil.org.br/requerimento/detalhe/${hash}`,
          '_blank'
        )
      },
      formatCpf (cpf) {
        if (!cpf) return 'Não informado'

        const digits = cpf.replace(/\D/g, '')

        if (digits.length !== 11) return cpf

        return digits.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/,
          '$1.$2.$3-$4'
        )
      }
    }
  }
</script>

<style lang="scss">
  .protocoloDetalhes {
    &_header {
      background: #074f7f;
      color: #fff;
      padding: 10px;
      font-size: 20px;
      font-weight: bold;
      border-radius: 0px;
    }

    &_content {
      border-radius: 0px;
    }

    &_body {
      padding: 20px;
    }

    &_body label {
      font-size: 16px;
      font-weight: 500;
      color: #000;
    }
  }

  .MenuImagens {
    border: 1px solid #000;

    &_header {
      background: #000;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      padding: 5px;
    }

    &_imagem {
      cursor: pointer;
      color: #000;
      font-size: 15px;
      padding: 5px;
      background: #fff;

      &_active {
        background: #086aae !important;
        color: #fff;
        transition: 0.2s;
      }
    }

    &_imagem:hover {
      background: #e2e2e2;
      transition: 0.2s;
    }
  }

  .Imagem {
    border: 1px solid black;
    width: 100%;
  }

  .document-preview {
    height: 500px !important;
  }

 .btn-primary,
 .btn-primary:hover,
 .btn-primary:focus,
 .btn-primary:active,
 .btn-primary:not(:disabled):not(.disabled):active {
   background-color: #074f7f !important;
   border-color: #074f7f !important;
   box-shadow: none !important;
 }

.btn-com-icone {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

</style>
